import { Sun, Moon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useChartTheme } from '@/hooks/useChartColors';

export default function ChartThemeToggle() {
  const { chartTheme, setChartTheme } = useChartTheme();
  
  const toggleTheme = () => {
    setChartTheme(chartTheme === 'light' ? 'dark' : 'light');
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            onClick={toggleTheme}
            className="gap-2"
          >
            {chartTheme === 'light' ? (
              <>
                <Sun className="h-4 w-4" />
                <span className="hidden sm:inline">Light Charts</span>
              </>
            ) : (
              <>
                <Moon className="h-4 w-4" />
                <span className="hidden sm:inline">Dark Charts</span>
              </>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Switch to {chartTheme === 'light' ? 'dark' : 'light'} chart background</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
